module.exports = __webpack_public_path__ + "static/media/help-icon.6f7283dd.svg";